import actions from './actions';
import types from './constants';
import SRS from '../../../../services/StudentRecordService';
import { hasPendingAssessment } from '../../util/pendingAssessment';
import get from 'lodash.get';

const fetchReport = (classId, student, selectedPercentiles) => async (dispatch, getState) => {
  let studentId = null
  if (student) studentId = student.value

  const state = getState();
  const locale = get(state, 'reports.teacher.selectedLocale');
  const useARM = selectedPercentiles && selectedPercentiles.state !== "US";
  dispatch(actions[types.READINGROPE_PENDING]())
  try {
    let requests = [SRS.getReadingRopeData({ classId, studentId, useARM, locale })]
    if(studentId){
      requests.push(hasPendingAssessment(studentId))
    }
    const [data, isPending] = await Promise.all(requests);
    data.isPending = isPending;
    dispatch(actions[types.READINGROPE_COMPLETE](data));
  }
  catch (e) {
    console.log("ERROR:",e)
    dispatch(actions[types.READINGROPE_ERROR](e))
  }
};

export default {
  fetchReport,
}